<template>
    <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover mb-0">
            <thead class="thead-light">
                <tr>
                    <th class="text-center">{{ "시간" }}</th>
                    <th class="text-center">{{ "집계값" }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="data in hourData" :key="data.regDt">
                    <td class="text-center">{{ data.regDt ? data.regDt : "-" }}</td>
                    <td class="text-right">{{ data.ptVal !== null ? data.ptVal.toFixed(1) : "-" }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import excelHelper from "@src/libs/excelHelper.js";

export default {
    props: {
        hourData: { type: Array, default: () => [] },
        flaghourDownload: { type: Boolean, default: false },
    },
    components: {},
    data() {
        return {};
    },
    watch: {
        flaghourDownload(val) {
            if (val) {
                this.exportToExcel();
            }
        },
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        async exportToExcel() {
            try {
                // 헤더 정의
                const headers = ["시간", "집계값"];

                // 데이터 변환 (excelHelper 형식에 맞게)
                const excelData = this.hourData.map((item) => ({
                    시간: item.regDt || "-",
                    집계값: item.ptVal !== null ? item.ptVal.toFixed(1) : "-",
                }));

                // 파일명 생성 (현재 날짜 포함)
                const currentDate = new Date().toISOString().slice(0, 10);
                const fileName = `1시간_집계_데이터_${currentDate}.xlsx`;

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName: "1시간_집계_데이터",
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths: {
                        시간: 15,
                        집계값: 15,
                    },
                    cellTypes: {
                        시간: "string",
                        집계값: "number",
                    },
                });

                this.$emit("download-finished");
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
                this.$emit("download-error", error.message);
            }
        },
    },
};
</script>

<style scoped>
.table-responsive {
    height: 32vh;
    /* height: 17.5rem; */
    overflow-y: auto;
    position: relative;
}
table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    table-layout: fixed;
}

thead {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
}
.table thead th {
    font-size: 13px;
    font-weight: 600;
}
.table tbody td {
    font-size: 13px;
}
</style>
